/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetExcelColumnsDto
 */
export interface GetExcelColumnsDto {
    /**
     * 
     * @type {string}
     * @memberof GetExcelColumnsDto
     */
    columnName: string;
    /**
     * 
     * @type {string}
     * @memberof GetExcelColumnsDto
     */
    columnNamePl: string;
    /**
     * 
     * @type {string}
     * @memberof GetExcelColumnsDto
     */
    columnNameEn: string;
}

/**
 * Check if a given object implements the GetExcelColumnsDto interface.
 */
export function instanceOfGetExcelColumnsDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "columnName" in value;
    isInstance = isInstance && "columnNamePl" in value;
    isInstance = isInstance && "columnNameEn" in value;

    return isInstance;
}

export function GetExcelColumnsDtoFromJSON(json: any): GetExcelColumnsDto {
    return GetExcelColumnsDtoFromJSONTyped(json, false);
}

export function GetExcelColumnsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetExcelColumnsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'columnName': json['columnName'],
        'columnNamePl': json['columnNamePl'],
        'columnNameEn': json['columnNameEn'],
    };
}

export function GetExcelColumnsDtoToJSON(value?: GetExcelColumnsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'columnName': value.columnName,
        'columnNamePl': value.columnNamePl,
        'columnNameEn': value.columnNameEn,
    };
}

